import React from "react";
import { Button } from "../components/ui/button";
import { ABOUT, BRAND } from "../mock";
import { ArrowRight, User } from "lucide-react";
import BrandLogo from "./BrandLogo";

export default function AboutCard({ onStart }) {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="bg-white rounded-2xl shadow-[0_8px_40px_rgba(11,21,53,0.08)] border border-gray-100 p-8 md:p-12 grid md:grid-cols-[1fr_280px] gap-10 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-extrabold text-navy leading-tight">
              {ABOUT.heading}
            </h2>
            <p className="mt-4 text-lg text-gray-600 leading-relaxed">
              {ABOUT.sub}
            </p>
          </div>
          <div className="justify-self-center">
            {ABOUT.photo ? (
              <img
                src={ABOUT.photo}
                alt={BRAND.name}
                className="w-56 h-64 object-cover rounded-md shadow-md"
              />
            ) : (
              <div className="w-56 h-64 rounded-md bg-gradient-to-br from-gray-100 to-gray-200 flex flex-col items-center justify-center text-gray-400 shadow-md">
                <User className="w-16 h-16 mb-2" strokeWidth={1.25} />
                <span className="text-xs uppercase tracking-widest">
                  Photo Coming Soon
                </span>
              </div>
            )}
          </div>
        </div>

        <div className="max-w-3xl mx-auto mt-20">
          <p className="font-bold text-navy text-lg mb-4">{ABOUT.intro}</p>
          <ul className="space-y-3">
            {ABOUT.bullets.map((b) => (
              <li key={b} className="flex items-start gap-3 text-navy">
                <span className="mt-1 w-6 h-6 rounded-full bg-navy flex items-center justify-center flex-shrink-0">
                  <ArrowRight className="w-3.5 h-3.5 text-white" />
                </span>
                <span className="text-base md:text-lg">{b}</span>
              </li>
            ))}
          </ul>

          <p className="mt-10 font-bold text-navy text-lg">{ABOUT.closing}</p>
          <p className="mt-2 text-gray-700 text-lg">{ABOUT.closingSub}</p>

          <div className="mt-10">
            <BrandLogo variant="yellow" className="h-16 opacity-70" />
          </div>
        </div>

        <div className="flex justify-center mt-16">
          <Button
            onClick={onStart}
            className="bg-paul-yellow hover:bg-paul-yellow text-navy font-bold px-12 py-6 text-base rounded-md shadow-md"
            style={{ color: "#0b1535" }}
          >
            Start Here
          </Button>
        </div>
      </div>
    </section>
  );
}
